<script setup lang="ts">
import { defineProps, ref } from 'vue';
import Button from 'primevue/button';
import DefaultInput from '../components/DefaultInput.vue';
import type { Calculation } from '../utils/types';
import { useSaveCalculation } from '../composables/useSaveCalculation';

const props = defineProps<{
  calculation: Calculation;
}>();

const { saveCalculation, isLoading } = useSaveCalculation();

const isEditing = ref(false);
const calculationName = ref(props.calculation.name);

async function handleSave() {
  await saveCalculation({
    ...props.calculation,
    name: calculationName.value,
  });

  isEditing.value = false;
}

function onClickOutside() {
  if (isEditing.value) {
    isEditing.value = false;
    calculationName.value = props.calculation.name;
  }
}
</script>

<template>
  <div class="flex items-end gap-2" v-click-outside="onClickOutside">
    <DefaultInput v-model="calculationName" :disabled="!isEditing"> Nazwa kalkulacji </DefaultInput>

    <Button v-if="!isEditing" severity="secondary" icon outlined="" @click.stop="isEditing = true">
      <i class="pi pi-pencil" />
    </Button>

    <Button
      v-else
      severity="secondary"
      :disabled="calculationName.length < 4 || isLoading"
      icon
      outlined=""
      :loading="isLoading"
      @click.stop="handleSave"
    >
      <i v-if="isLoading" class="pi pi-spin pi-spinner" />
      <i v-else class="pi pi-save" />
    </Button>
  </div>
</template>
